import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import UpdateAttUser from "../UpdateAttUser";
import ImgWithSignedUrl from "components/SignedUrl/ImgWithSignedUrl";

export default function AttUserInfo({ userData, refreshFunc }) {
  /*   All States
   ********************************************* */
  const [showUserEditModal, setShowUserEditModal] = useState(null);
  const [weeklySchedule, setWeeklySchedule] = useState(null);

  /*   All Functions
   ********************************************* */
  const get12HoursFormat = (outTime) => {
    if (!outTime) return "-";
    let time = outTime?.split(":");
    let hours = parseInt(time[0]);
    let minutes = time[1];
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    return `${hours}:${minutes}`;
  };

  /*   All UseEffects
   ********************************************* */

  useEffect(() => {
    if (userData) {
      let weeklySchedule = JSON.parse(userData?.weeklySchedule);
      setWeeklySchedule(weeklySchedule);
    }
  }, [userData]);

  return (
    <div>
      <div className="bg-white custom-shadow-sm px-3 py-2 custom-border-radius-sm mb-3">
        <div className="">
          <div>
            <div className="d-flex gap-3 align-items-center">
              <h3 className="border-bottom">User Info</h3>
              <button
                disabled={!userData}
                onClick={(e) => {
                  setShowUserEditModal(true);
                }}
                className="btn btn-info btn-sm px-1 py-0"
              >
                <i className="mdi fs-5 mdi-pencil"></i>
              </button>
            </div>
            <div className="d-flex align-items-start gap-3">
              <div className="fw-extrabold h4">
                <div className="mb-2">Id</div>
                <div className="mb-2">Name</div>
                <div className="mb-2">Badge No </div>
                {/* <div className="mb-2">Relaxation Time </div> */}
                <div className="mb-2">Card Number</div>
                <div className="mb-2">Role</div>
                <div className="mb-2">Is Night Office User?</div>
              </div>
              <div className="h4">
                <div className="mb-2">{userData?.userId}</div>
                <div className="mb-2">{userData?.name || "-"}</div>
                <div className="mb-2">{userData?.badgeNo || "-"}</div>

                {/* <div className="mb-2">{userData?.relaxationMinutes || "-"}</div> */}
                <div className="mb-2">{userData?.cardno || "-"}</div>
                <div className="mb-2">
                  {userData?.role === "14" ? "Admin" : "User"}
                </div>
                <div className="mb-2">
                  {userData?.isNightOffice ? "Yes" : "No"}
                </div>
              </div>
            </div>
          </div>

          <div className="">
            <h3 className="border-bottom mb-3">Schedule </h3>
            <div className="row">
              <div className="col-md-7">
                {weeklySchedule &&
                  Object.keys(weeklySchedule)?.map((dayName, index) => {
                    let schedule = weeklySchedule[dayName];
                    return (
                      <div key={index} className="row mb-1">
                        <div className="col-md-6 fw-bold ">{dayName}</div>
                        <div className="col-md-6">
                          {schedule?.inTime} -{" "}
                          {get12HoursFormat(schedule?.outTime)}
                        </div>
                      </div>
                    );
                  })}
              </div>
              {weeklySchedule ? (
                <div className="col-md-5">
                  {userData?.picture ? (
                    <ImgWithSignedUrl path={userData?.picture} width={150} />
                  ) : (
                    <img
                      src="https://placehold.co/150"
                      className="img-fluid"
                      alt=""
                    />
                  )}
                </div>
              ) : (
                <h4 className="text-danger">Please Set User Schedule First</h4>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="xl"
        show={showUserEditModal}
        onHide={() => setShowUserEditModal(false)}
        contentClassName="bg-transparent"
      >
        <Modal.Body className="bg-white custom-border-radius p-3 py-2 pb-3">
          <UpdateAttUser
            showModal={setShowUserEditModal}
            userData={userData}
            refreshFunc={refreshFunc}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
